var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_vm._l((_vm.blocks),function(block){return [(_vm.hasAccess({ action: 'GET', resource: _vm.multinationalSlug(block) }))?_c('div',{key:block.link},[_c('DashboardCallToActionBlock',{attrs:{"block":block}})],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }